import { useState } from 'react';
import { useCreateAccountContext } from './Context';

export const CreateAccountClient = () => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const { loading, handleSubmitAccountClient } = useCreateAccountContext();

    return (
        <form
            className="space-y-5"
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmitAccountClient({ name: name.trim(), email: email.trim() });
            }}
        >
            <label className="form-control w-full">
                <span className="mb-1.5 text-sm font-medium">Nome</span>
                <input
                    type="text"
                    name="name"
                    disabled={loading}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="input input-bordered h-12 w-full rounded-xl"
                    placeholder="Seu nome completo"
                    autoComplete="name"
                    required
                />
            </label>

            <label className="form-control w-full">
                <span className="mb-1.5 text-sm font-medium">E-mail</span>
                <input
                    type="email"
                    name="email"
                    disabled={loading}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input input-bordered h-12 w-full rounded-xl"
                    placeholder="nome@email.com"
                    autoComplete="email"
                    inputMode="email"
                    required
                />
                <span className="mt-1.5 text-xs text-base-content/50">
                    Você vai receber um link para criar sua senha.
                </span>
            </label>

            <button type="submit" disabled={loading} className="btn btn-primary h-12 w-full rounded-xl">
                {loading ? <span className="loading loading-spinner loading-sm" /> : 'Continuar'}
            </button>
        </form>
    );
};
